import { Cartography } from 'src/Containers/Cartography';

import styles from './StructureSection.module.scss';

const StructureSection = () => {
  return (
    <div className={styles.container}>
      <Cartography />
    </div>
  );
};

export default StructureSection;
